import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, Tabs, Card, Switch, Divider } from 'antd';

import { Form } from 'antd';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import FormInput from 'components/FormInput';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import ParListSelect from 'components/ParListSelect';
import FormulaList from 'components/FormulaList';
import AddresseListSelect from '../AddressesListSelect';
import BankAccountListSelect from '../BankAccListSelect';
import ButtonOperation from 'components/ButtonOperation';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type RoleModalProps = {
  tpid: number;
  record?: any;
  onClose?: any;
  visible: boolean;
  updateRole?: boolean;
  onSave: (add: any) => void;
  initadd: any;
  showAsModal?: boolean;
};

const RoleModal = (props: RoleModalProps) => {
  const {
    onClose,
    onSave,
    initadd,
    updateRole = false,
    visible = false,
    record,
    showAsModal,
  } = props;
  const [form] = Form.useForm();

  const [state, setstate] = useState<any>({
    RoleElement: updateRole ? record : initadd,
  });

  const reset = () => {
    setstate({ ...state, AddressElement: updateRole ? record : initadd });
  };

  useEffect(() => {
    form.setFieldsValue(record ?? initadd);
  }, [form, record, initadd]);

  return (
    <Modal
      visible={visible}
      title={record ? 'Update Role' : 'Add Role'}
      width="1200px"
      style={{ top: 100 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
        reset();
      }}
    >
      <Card>
        <Form form={form} onFinish={(e) => {}}>
          <Tabs
            type="card"
            tabBarExtraContent={
              !showAsModal && (
                <Row gutter={16}>
                  <Col span={0} />

                  <Col span={10}>
                    <ButtonOperation comcode="Cancel" onClick={onClose} />
                  </Col>
                  <Col span={13}>
                    <ButtonOperation
                      icon={record ? <IUpdate></IUpdate> : <IAdd></IAdd>}
                      comcode={record ? 'Update' : 'Add'}
                      htmlType="button"
                      onClick={() => {
                        let e = form.getFieldsValue();
                        e = {
                          ...e,
                          tproleid: form.getFieldValue('tproleid'),
                          tpadrid:
                            typeof form.getFieldValue('address') === 'object'
                              ? e.address.tpadrid
                              : e.address,
                        };

                        onSave(e);
                        onClose();
                      }}
                    />
                  </Col>
                </Row>
              )
            }
          ></Tabs>
          <Row gutter={16}>
            <FormInput 
             col 
             xs={8} 
             name="tprolecode"
             labelCol={{span:11}}
            >
              <ParListSelect parcode="TPMAINROLE" disabled={record} />
            </FormInput>
            <FormInput 
             col 
             xs={12} 
             name="address"
             labelCol={{span:7}}
            >
              <AddresseListSelect
                params={{ tpid: props.tpid }}
                onSelected={(e) =>
                  form?.setFieldsValue({
                    adrtype: e?.adrtype ?? 'MAIN',
                    adrstatus: e?.adrstatus ?? 'VALID',
                  })
                }
              />
            </FormInput>
            <Divider orientation='left'><GetLabel label="Paiement"/></Divider>
            <FormInput 
              col 
              xs={8} 
              name="tppaymodein"
              labelCol={{span:11}}
            >
              <ParListSelect parcode="PAYMODEIN" />
            </FormInput>
            <FormInput 
              col 
              xs={8} 
              name="tppaydelayin"
              labelCol={{span:11}}
            >
              <ParListSelect parcode="PAYDELAYIN" />
            </FormInput>
            <FormInput 
              col
              xs={8} 
              name="tpbkidin"
              labelCol={{span:11}}
            >
              <BankAccountListSelect
                params={{ tpid: props.tpid, allowedBktype: ['IN', 'INOUT'] }}
                onSelected={(e) =>
                  form?.setFieldsValue({
                    bktype: e?.bktype,
                    bkstatus: e?.bkstatus ?? 'VALID',
                  })
                }
              />
            </FormInput>

            <FormInput 
              col 
              xs={8} 
              name="tppaymodeout"
              labelCol={{span:11}}
            >
              <ParListSelect parcode="PAYMODEOUT" />
            </FormInput>
            <FormInput 
              col 
              xs={8} 
              name="tppaydelayout"
              labelCol={{span:11}}
            >
              <ParListSelect parcode="PAYDELAYOU" />
            </FormInput>
            <FormInput 
              col 
              xs={8}
              name="tpbkidout"
              labelCol={{span:11}}
            >
              <BankAccountListSelect
                params={{ tpid: props.tpid, allowedBktype: ['OUT', 'INOUT'] }}
                onSelected={(e) =>
                  form?.setFieldsValue({
                    bktype: e?.bktype,
                    bkstatus: e?.bkstatus ?? 'VALID',
                  })
                }
              />
            </FormInput>
            <Divider orientation='left'><GetLabel label="Fees"/></Divider>
            <FormInput 
             col 
             xs={12} 
             name="tplateinterestformula"
             labelCol={{span:7}}
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'LATEIN',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <FormInput
              col
              xs={10}
              name="tpblocklateinterestinvoicing"
              valuePropName="checked"
              labelCol={{span:16}}
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked
              />
            </FormInput>
            <FormInput 
              col 
              xs={12} 
              name="tprejectionfeesformula"
              labelCol={{span:7}}
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REJFEES',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <FormInput
              col
              xs={10}
              name="tpblockrejectionfeesinvoicing"
              valuePropName="checked"
              labelCol={{span:16}}
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked
              />
            </FormInput>
            <FormInput 
              col 
              xs={12} 
              name="tpreminderfeesformula"
              labelCol={{span:7}}
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REMINF',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
              />
            </FormInput>
            <FormInput
              col
              xs={10}
              name="tpblockreminderfeesinvoicing"
              valuePropName="checked"
              labelCol={{span:16}}
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked
              />
            </FormInput>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default RoleModal;
